import React, {useEffect} from 'react';
import {ScrollView, View} from 'react-native';
import {noop} from 'lodash';

import {getTodayDetails} from '/component/screen/Dashboard/Edge365/Edge365MainScreen/Edge365MainScreen.util';

import Edge365Card from './Edge365/Edge365Card';
import {BusinessBuilderBonusProfileCard} from './BusinessBuilderBonusProfileCard';
import MiscMetrics from './MiscMetrics';
import OrderMetrics from './OrderMetrics';
import {styles} from './PerformanceTab.style';
import RankProgression from './RankProgression';

interface PerformanceTabProps {
  coachId: number | string;
  onShowInfoPopover: () => void;
  hasNextRank: boolean;
  popoverShow: () => void;
  reportName: string;
  hasBusinessBuilderBonusContributors: boolean;
  showBusinessBuilderBonusProfileCard: boolean;
  latestStreakData: any;
  highestStreakData: any;
  getEdge365ChallengeTasks: (params: {
    coachId: number | string;
    month: number;
    year: number;
  }) => void;
  hasEdge365ChallengeTasks: boolean;
}

export const PerformanceTab = ({
  coachId = '',
  onShowInfoPopover = noop,
  hasNextRank = false,
  popoverShow = noop,
  reportName = '',
  hasBusinessBuilderBonusContributors = false,
  showBusinessBuilderBonusProfileCard = false,
  latestStreakData,
  highestStreakData,
  getEdge365ChallengeTasks = noop,
  hasEdge365ChallengeTasks = false,
}: PerformanceTabProps) => {
  useEffect(() => {
    const year = getTodayDetails().year;
    const month = getTodayDetails().month;

    if (!hasEdge365ChallengeTasks) {
      getEdge365ChallengeTasks({coachId, month, year});
    }
  }, [coachId, hasEdge365ChallengeTasks]);

  return (
    <ScrollView
      style={styles.base}
      contentContainerStyle={styles.contentContainer}>
      <Edge365Card
        latestStreakData={latestStreakData}
        highestStreakData={highestStreakData}
        coachId={coachId}
      />
      <View style={styles.content}>
        {hasNextRank && (
          <RankProgression
            coachId={coachId}
            onShowInfoPopover={onShowInfoPopover}
            hasBusinessBuilderBonusContributors={
              hasBusinessBuilderBonusContributors
            }
          />
        )}
        {hasBusinessBuilderBonusContributors &&
          showBusinessBuilderBonusProfileCard && (
            <BusinessBuilderBonusProfileCard
              coachId={coachId}
              popoverShow={popoverShow}
              reportName={reportName}
            />
          )}
        <OrderMetrics coachId={coachId} onShowInfoPopover={onShowInfoPopover} />
        <MiscMetrics coachId={coachId} onShowInfoPopover={onShowInfoPopover} />
      </View>
    </ScrollView>
  );
};

export default PerformanceTab;
